<template>
  <AuthCompleteLayout class="complete-v2">
    <!-- ========== LEFT PANEL ========== -->
    <template #left>
      <transition
        name="narrative"
        mode="out-in"
      >
        <div
          :key="`illu-${currentStep.id}`"
          class="complete-v2__illustration"
          :class="{ 'complete-v2__illustration--rocket': currentStep.id === 'liftOff' }"
        >
          <span class="complete-v2__illustration-halo complete-v2__illustration-halo--outer" />
          <span class="complete-v2__illustration-halo complete-v2__illustration-halo--inner" />
          <svg
            v-if="currentStep.id === 'liftOff'"
            class="complete-v2__illustration-svg complete-v2__illustration-svg--rocket"
            viewBox="-60 -110 120 220"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="0"
              cy="95"
              rx="52"
              ry="5"
              fill="#94c840"
              opacity="0.35"
            />
            <g class="complete-v2__rocket-body">
              <path
                d="M0,-90 L32,30 L16,40 L16,80 L-16,80 L-16,40 L-32,30 Z"
                fill="#ffffff"
              />
              <circle
                cx="0"
                cy="-25"
                r="10"
                fill="#94c840"
              />
              <path
                d="M-16,80 L-32,100 L-10,90 Z"
                fill="#f0b72f"
              />
              <path
                d="M16,80 L32,100 L10,90 Z"
                fill="#f0b72f"
              />
              <path
                class="complete-v2__rocket-flame"
                d="M0,90 L-8,130 L8,130 Z"
                fill="#ef4444"
              />
            </g>
          </svg>
          <svg
            v-else-if="currentStep.id === 'userInfos'"
            class="complete-v2__illustration-svg"
            viewBox="-60 -60 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="0"
              cy="5"
              r="42"
              fill="#ffffff"
              opacity="0.05"
            />
            <circle
              cx="0"
              cy="5"
              r="30"
              fill="#ffffff"
              opacity="0.08"
            />

            <g class="complete-v2__person">
              <path
                d="M-32,45 C-32,10 32,10 32,45 Z"
                fill="#ffffff"
              />
              <path
                d="M-10,14 L0,26 L10,14 Z"
                fill="#94c840"
              />
              <rect
                x="-2"
                y="26"
                width="4"
                height="15"
                fill="#94c840"
                rx="2"
              />
              <circle
                cx="0"
                cy="-12"
                r="18"
                fill="#ffffff"
              />
              <path
                d="M-18,-12 C-18,-35 18,-35 18,-12 C18,-22 -5,-25 -18,-12 Z"
                fill="#d4e7af"
              />
              <circle
                cx="-6"
                cy="-13"
                r="2.2"
                fill="#262a27"
              />
              <circle
                cx="6"
                cy="-13"
                r="2.2"
                fill="#262a27"
              />
              <circle
                cx="-12"
                cy="-8"
                r="2.5"
                fill="#ef4444"
                opacity="0.25"
              />
              <circle
                cx="12"
                cy="-8"
                r="2.5"
                fill="#ef4444"
                opacity="0.25"
              />
              <path
                d="M-5,-5 Q0,2 5,-5"
                stroke="#262a27"
                stroke-width="2.2"
                fill="none"
                stroke-linecap="round"
              />
            </g>

            <g class="complete-v2__wave-hand">
              <path
                d="M20,32 Q32,28 35,16"
                stroke="#ffffff"
                stroke-width="11"
                stroke-linecap="round"
                fill="none"
              />
              <path
                d="M25,14 C25,5 38,5 41,12 C43,20 35,24 29,22 Z"
                fill="#ffffff"
              />
              <line
                x1="31"
                y1="6"
                x2="29"
                y2="-4"
                stroke="#ffffff"
                stroke-width="4.5"
                stroke-linecap="round"
              />
              <line
                x1="35"
                y1="5"
                x2="35"
                y2="-6"
                stroke="#ffffff"
                stroke-width="4.5"
                stroke-linecap="round"
              />
              <line
                x1="39"
                y1="7"
                x2="41"
                y2="-2"
                stroke="#ffffff"
                stroke-width="4.5"
                stroke-linecap="round"
              />
              <line
                x1="42"
                y1="11"
                x2="45"
                y2="5"
                stroke="#ffffff"
                stroke-width="4"
                stroke-linecap="round"
              />
              <line
                x1="27"
                y1="12"
                x2="21"
                y2="8"
                stroke="#ffffff"
                stroke-width="4.5"
                stroke-linecap="round"
              />
            </g>

            <g class="complete-v2__sparkles">
              <path
                d="M15,-12 L17,-19 L24,-21 L17,-23 L15,-30 L13,-23 L6,-21 L13,-19 Z"
                fill="#f0b72f"
              />
              <path
                d="M46,-16 L47,-20 L51,-21 L47,-22 L46,-26 L45,-22 L41,-21 L45,-20 Z"
                fill="#94c840"
              />
            </g>
          </svg>
          <svg
            v-else-if="currentStep.id === 'shopConfirm'"
            class="complete-v2__illustration-svg"
            viewBox="-60 -60 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="-30"
              y="-44"
              width="60"
              height="14"
              rx="3"
              fill="#ffffff"
            />
            <circle
              cx="-18"
              cy="-37"
              r="2.5"
              fill="#94c840"
            />
            <circle
              cx="-6"
              cy="-37"
              r="2.5"
              fill="#94c840"
            />
            <circle
              cx="6"
              cy="-37"
              r="2.5"
              fill="#94c840"
            />
            <circle
              cx="18"
              cy="-37"
              r="2.5"
              fill="#94c840"
            />
            <path
              d="M-52,-28 L52,-28 L56,-10 L-56,-10 Z"
              fill="#94c840"
            />
            <path
              d="M-36,-28 L-40,-10"
              stroke="#ffffff"
              stroke-width="3"
              opacity="0.45"
            />
            <path
              d="M-14,-28 L-18,-10"
              stroke="#ffffff"
              stroke-width="3"
              opacity="0.45"
            />
            <path
              d="M8,-28 L4,-10"
              stroke="#ffffff"
              stroke-width="3"
              opacity="0.45"
            />
            <path
              d="M30,-28 L26,-10"
              stroke="#ffffff"
              stroke-width="3"
              opacity="0.45"
            />
            <rect
              x="-48"
              y="-10"
              width="96"
              height="58"
              fill="#ffffff"
            />
            <rect
              x="-40"
              y="2"
              width="24"
              height="28"
              rx="2"
              fill="#d4e7af"
            />
            <line
              x1="-28"
              y1="2"
              x2="-28"
              y2="30"
              stroke="#ffffff"
              stroke-width="1.5"
            />
            <line
              x1="-40"
              y1="16"
              x2="-16"
              y2="16"
              stroke="#ffffff"
              stroke-width="1.5"
            />
            <rect
              x="16"
              y="2"
              width="24"
              height="28"
              rx="2"
              fill="#d4e7af"
            />
            <line
              x1="28"
              y1="2"
              x2="28"
              y2="30"
              stroke="#ffffff"
              stroke-width="1.5"
            />
            <line
              x1="16"
              y1="16"
              x2="40"
              y2="16"
              stroke="#ffffff"
              stroke-width="1.5"
            />
            <rect
              x="-11"
              y="14"
              width="22"
              height="34"
              rx="2"
              fill="#94c840"
            />
            <circle
              cx="5"
              cy="32"
              r="1.8"
              fill="#f0b72f"
            />
            <rect
              x="-54"
              y="48"
              width="108"
              height="5"
              fill="#262a27"
              opacity="0.25"
            />
          </svg>
          <svg
            v-else-if="currentStep.id === 'connect'"
            class="complete-v2__illustration-svg"
            viewBox="-60 -60 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- Cloud (Shopimind) at top -->
            <g class="complete-v2__connect-cloud">
              <circle
                cx="-14"
                cy="-40"
                r="9"
                fill="#ffffff"
              />
              <circle
                cx="4"
                cy="-46"
                r="11"
                fill="#ffffff"
              />
              <circle
                cx="18"
                cy="-40"
                r="8"
                fill="#ffffff"
              />
              <ellipse
                cx="2"
                cy="-34"
                rx="24"
                ry="8"
                fill="#ffffff"
              />
              <circle
                cx="2"
                cy="-38"
                r="4"
                fill="#94c840"
              />
            </g>

            <!-- Signal waves (shop → cloud) -->
            <g class="complete-v2__connect-waves">
              <path
                class="complete-v2__connect-wave complete-v2__connect-wave--1"
                d="M-8,2 Q0,-6 8,2"
                stroke="#94c840"
                stroke-width="3.5"
                fill="none"
                stroke-linecap="round"
              />
              <path
                class="complete-v2__connect-wave complete-v2__connect-wave--2"
                d="M-14,-6 Q0,-18 14,-6"
                stroke="#94c840"
                stroke-width="3.5"
                fill="none"
                stroke-linecap="round"
              />
              <path
                class="complete-v2__connect-wave complete-v2__connect-wave--3"
                d="M-20,-14 Q0,-28 20,-14"
                stroke="#94c840"
                stroke-width="3.5"
                fill="none"
                stroke-linecap="round"
              />
            </g>

            <!-- Shop building -->
            <g class="complete-v2__connect-shop">
              <!-- Awning -->
              <path
                d="M-30,14 L30,14 L34,6 L-34,6 Z"
                fill="#94c840"
              />
              <!-- Awning stripes -->
              <line
                x1="-22"
                y1="14"
                x2="-26"
                y2="6"
                stroke="#ffffff"
                stroke-width="2"
                opacity="0.4"
              />
              <line
                x1="-8"
                y1="14"
                x2="-12"
                y2="6"
                stroke="#ffffff"
                stroke-width="2"
                opacity="0.4"
              />
              <line
                x1="8"
                y1="14"
                x2="4"
                y2="6"
                stroke="#ffffff"
                stroke-width="2"
                opacity="0.4"
              />
              <line
                x1="22"
                y1="14"
                x2="18"
                y2="6"
                stroke="#ffffff"
                stroke-width="2"
                opacity="0.4"
              />
              <!-- Body -->
              <rect
                x="-28"
                y="14"
                width="56"
                height="34"
                fill="#ffffff"
              />
              <!-- Window left -->
              <rect
                x="-22"
                y="22"
                width="12"
                height="10"
                rx="1"
                fill="#d4e7af"
              />
              <line
                x1="-16"
                y1="22"
                x2="-16"
                y2="32"
                stroke="#ffffff"
                stroke-width="1.2"
              />
              <!-- Window right -->
              <rect
                x="10"
                y="22"
                width="12"
                height="10"
                rx="1"
                fill="#d4e7af"
              />
              <line
                x1="16"
                y1="22"
                x2="16"
                y2="32"
                stroke="#ffffff"
                stroke-width="1.2"
              />
              <!-- Door -->
              <rect
                x="-6"
                y="26"
                width="12"
                height="22"
                rx="1"
                fill="#94c840"
              />
              <circle
                cx="3"
                cy="38"
                r="1.2"
                fill="#f0b72f"
              />
              <!-- Ground shadow -->
              <ellipse
                cx="0"
                cy="52"
                rx="36"
                ry="2.5"
                fill="#000000"
                opacity="0.22"
              />
            </g>

            <!-- Sparkles -->
            <g class="complete-v2__sparkles">
              <path
                d="M-34,-18 L-33,-22 L-29,-23 L-33,-24 L-34,-28 L-35,-24 L-39,-23 L-35,-22 Z"
                fill="#f0b72f"
              />
              <circle
                cx="32"
                cy="-18"
                r="2"
                fill="#94c840"
                opacity="0.85"
              />
            </g>
          </svg>
        </div>
      </transition>

      <transition
        name="narrative"
        mode="out-in"
      >
        <div
          :key="currentStep.id"
          class="complete-v2__narrative"
        >
          <p class="complete-v2__eyebrow">
            <span class="complete-v2__eyebrow-bar" />
            {{ t('completeV2.step', { current: currentIndex + 1, total: totalSteps }) }}
          </p>
          <h1 class="complete-v2__headline">
            {{ narrativeHeadline }}
          </h1>
          <p
            v-if="narrativeSubtitle"
            class="complete-v2__subtitle"
          >
            {{ narrativeSubtitle }}
          </p>
        </div>
      </transition>

      <div
        id="onboarding-left-extra"
        class="complete-v2__extra"
      />
    </template>

    <!-- ========== LEFT FOOTER ========== -->
    <template #left-footer>
      <DotsProgress
        :total="totalSteps"
        :current-index="currentIndex"
      />
      <p class="complete-v2__copy">
        &copy; {{ new Date().getFullYear() }} ShopiMind
      </p>
    </template>

    <!-- ========== RIGHT HEADER ========== -->
    <template #right-header>
      <MySitesMenu
        v-if="userShopsCount > 1"
        :add-shop="false"
      />
      <SpmButton
        :label="t('completeV2.helpCta')"
        icon="far fa-comments"
        class-style="p-button-text p-button-secondary"
        @click="openSupport"
      />
      <SpmButton
        :label="t('completeV2.laterCta')"
        class-style="p-button-text p-button-secondary"
        @click="openLaterModal"
      />
    </template>

    <!-- ========== RIGHT BODY ========== -->
    <div
      v-if="bootLoading"
      class="complete-v2__boot"
    >
      <i class="far fa-spinner-third fa-spin" />
    </div>
    <component
      :is="currentStep.component"
      v-else
      :key="currentStep.id"
      :can-go-back="!isFirst"
      @next="handleNext"
      @back="handleBack"
    />

    <!-- ========== RIGHT FOOTER (step footer portal) ========== -->
    <template #right-footer>
      <div id="onboarding-footer" />
    </template>
  </AuthCompleteLayout>

  <Dialog
    v-model:visible="laterModalVisible"
    :header="t('completeV2.logoutModal.title')"
    :modal="true"
    :closable="true"
    :style="{ width: '420px' }"
  >
    <p>{{ t('completeV2.logoutModal.message') }}</p>
    <template #footer>
      <SpmButton
        :label="t('completeV2.logoutModal.cancel')"
        class-style="p-button p-button-secondary"
        @click="laterModalVisible = false"
      />
      <SpmButton
        :label="t('completeV2.logoutModal.confirm')"
        class-style="p-button p-button-success"
        @click="handleLogout"
      />
    </template>
  </Dialog>
</template>

<script lang="ts">
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Dialog from 'primevue/dialog';
import Gleap from 'gleap';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import { Logout, Me, UserState } from '@/composables/User';
import { useStore } from '@/store';
import { getErrorMessage, showToastError } from '@/helpers';
import { useOnboardingState, getPersistedIndex } from '@/composables/onboarding-v2/useOnboardingState';
import { useOnboardingProfile } from '@/composables/onboarding-v2/useOnboardingProfile';
import { resolveTargetIndex } from '@/composables/onboarding-v2/useOnboardingValidators';
import DotsProgress from '@/components/onboarding-v2/shared/DotsProgress.vue';
import OnboardingV2Components from '@/components/onboarding-v2';
import AuthCompleteLayout from '@/views/layout/AuthCompleteLayout.vue';
import MySitesMenu from '@/components/header/MySitesMenu.vue';

export default defineComponent({
  name: 'CompleteV2',

  components: {
    Dialog,
    SpmButton,
    DotsProgress,
    AuthCompleteLayout,
    MySitesMenu,
    ...OnboardingV2Components,
  },

  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();

    const {
      totalSteps,
      currentIndex,
      currentStep,
      isFirst,
      isLast,
      setIndex,
      goNext,
      goPrev,
      clearPersisted,
    } = useOnboardingState();

    const laterModalVisible = ref(false);
    const bootLoading = ref(true);

    const { profile, preload } = useOnboardingProfile();

    // Détermine si l'étape courante doit afficher la variante "Alt" du
    // narratif (gauche). Critères côté étape :
    //   - userInfos : tous les champs profil (sauf vatNumber) déjà remplis
    //                 → on demande de "vérifier" plutôt que "renseigner".
    //   - shopConfirm : il MANQUE name OU currency OU langue par défaut
    //                   → on n'a rien deviné, on demande à compléter.
    // Suffix appliqué aux clés i18n du narratif gauche selon le contexte de
    // l'étape :
    //   - 'Alt' : variante "déjà rempli" (userInfos) ou "rien deviné"
    //             (shopConfirm).
    //   - 'Shopify' : étape `connect` pour une boutique Shopify, où le flow
    //                 d'auto-provisioning ne demande pas de copier-coller.
    const narrativeSuffix = computed<string>(() => {
      const stepId = currentStep.value.id;
      if (stepId === 'connect'
        && UserState.activeShop?.solutionEcommerce === 'shopify') {
        return 'Shopify';
      }
      if (stepId === 'userInfos') {
        const filled = !!(
          profile.firstName
          && profile.lastName
          && profile.societe
          && profile.rue
          && profile.zipCode
          && profile.city
          && profile.country
          && profile.phoneMobile
        );
        return filled ? 'Alt' : '';
      }
      if (stepId === 'shopConfirm') {
        const shop = UserState.activeShop;
        const hasDefaultLang = Array.isArray(shop?.langs)
          && shop!.langs.some((l) => l.default);
        const hasAll = !!(shop?.name && shop?.currency && hasDefaultLang);
        return hasAll ? '' : 'Alt';
      }
      return '';
    });

    const narrativeHeadline = computed(
      () => t(`completeV2.steps.${currentStep.value.id}.narrativeHeadline${narrativeSuffix.value}`),
    );
    const narrativeSubtitle = computed(
      () => t(`completeV2.steps.${currentStep.value.id}.narrativeSubtitle${narrativeSuffix.value}`),
    );

    const userShopsCount = computed(() => UserState.user?.shops?.length ?? 0);

    onMounted(async () => {
      try {
        Gleap.setLanguage(UserState.user?.lang ?? 'en');
        Gleap.initialize(process.env.VUE_APP_GLEAP_API_KEY || '');
        Gleap.setMaxNetworkRequests(50);
        Gleap.showFeedbackButton(false);
      } catch (e) {
        // Gleap init failure shouldn't block onboarding
      }

      try {
        await preload();
        const target = await resolveTargetIndex(getPersistedIndex());
        setIndex(target);
      } finally {
        bootLoading.value = false;
      }
    });

    const openLaterModal = () => {
      laterModalVisible.value = true;
    };

    const openSupport = () => {
      try {
        Gleap.open();
      } catch (e) {
        // noop
      }
    };

    const handleNext = async () => {
      if (isLast.value) {
        clearPersisted();
        store.commit('general/showTheSpinner');
        try {
          await Me(true, UserState.activeShop?.id);
        } finally {
          store.commit('general/hideTheSpinner');
        }
        await router.push({ name: 'home' });
        return;
      }
      goNext();
    };

    const handleBack = () => {
      goPrev();
    };

    const handleLogout = async () => {
      laterModalVisible.value = false;
      store.commit('general/showTheSpinner');
      try {
        clearPersisted();
        await Logout();
      } catch (error) {
        await showToastError('GENERIC_ERROR');
      } finally {
        await router.push({ name: 'login' });
        store.commit('general/hideTheSpinner');
        window.location.reload();
      }
    };

    return {
      t,
      totalSteps,
      currentIndex,
      currentStep,
      isFirst,
      narrativeHeadline,
      narrativeSubtitle,
      bootLoading,
      laterModalVisible,
      userShopsCount,
      openLaterModal,
      openSupport,
      handleNext,
      handleBack,
      handleLogout,
    };
  },
});
</script>

<style lang="scss" scoped>
.complete-v2 {
  &__illustration {
    position: relative;
    align-self: center;
    width: 180px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.25rem;

    &--rocket {
      width: 220px;
      height: 220px;
    }
  }

  &__illustration-halo {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;

    &--outer {
      width: 100%;
      height: 100%;
      background: rgba(148, 200, 64, 0.14);
    }

    &--inner {
      width: 68%;
      height: 68%;
      background: rgba(148, 200, 64, 0.24);
    }
  }

  &__illustration-emoji {
    position: relative;
    z-index: 1;
    font-size: 3.75rem;
    line-height: 1;
    filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.25));
  }

  &__illustration-svg {
    position: relative;
    z-index: 1;
    width: 72%;
    height: 72%;
    overflow: visible;
    filter: drop-shadow(0 10px 22px rgba(0, 0, 0, 0.3));

    &--rocket {
      width: 78%;
      height: 78%;
      filter: drop-shadow(0 14px 28px rgba(0, 0, 0, 0.35));
    }
  }

  &__rocket-body {
    transform-origin: center;
    animation: rocket-float 2.4s ease-in-out infinite;
  }

  &__rocket-flame {
    transform-origin: center top;
    animation: rocket-flame 0.35s ease-in-out infinite;
  }

  &__person {
    transform-origin: center bottom;
    animation: bounce-soft 3s ease-in-out infinite;
  }

  &__wave-hand {
    transform-origin: 22px 28px;
    animation: wave-hello 1.8s ease-in-out infinite;
  }

  &__sparkles {
    transform-origin: center;
    animation: pulse-sparkle 2s ease-in-out infinite;
  }

  &__connect-cloud {
    transform-origin: center;
    animation: cloud-float 3s ease-in-out infinite;
  }

  &__connect-shop {
    transform-origin: center bottom;
    animation: bounce-soft 3.2s ease-in-out infinite;
  }

  &__connect-wave {
    opacity: 0;
    transform-origin: center;
    animation: wave-emit 2.1s ease-out infinite;

    &--1 { animation-delay: 0s; }
    &--2 { animation-delay: 0.35s; }
    &--3 { animation-delay: 0.7s; }
  }

  &__narrative {
    display: flex;
    flex-direction: column;
  }

  &__eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    font-size: 0.7rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #94c840;
    font-weight: 700;
    margin: 0 0 0.85rem;
  }

  &__eyebrow-bar {
    width: 18px;
    height: 2px;
    background: #94c840;
    border-radius: 2px;
    display: inline-block;
  }

  &__headline {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.01em;
    margin: 0 0 0.65rem;
    color: #ffffff;
  }

  &__subtitle {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.55;
    margin: 0;
  }

  &__extra {
    &:empty { display: none; }
  }

  &__copy {
    margin: 0;
    font-size: 0.6875rem;
    color: rgba(255, 255, 255, 0.25);
  }

  &__boot {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    color: #94c840;
  }
}

@keyframes rocket-float {
  0%, 100% { transform: translateY(6px); }
  50% { transform: translateY(-6px); }
}

@keyframes rocket-flame {
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(1.25); }
}

@keyframes bounce-soft {
  0%, 100% { transform: translateY(0) scaleY(1); }
  50% { transform: translateY(-2px) scaleY(1.02); }
}

@keyframes wave-hello {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-12deg); }
  75% { transform: rotate(18deg); }
}

@keyframes pulse-sparkle {
  0%, 100% { opacity: 0.6; transform: scale(0.9); }
  50% { opacity: 1; transform: scale(1.1); }
}

@keyframes cloud-float {
  0%, 100% { transform: translateY(-1px); }
  50% { transform: translateY(3px); }
}

@keyframes wave-emit {
  0% { opacity: 0; transform: scale(0.6); }
  30% { opacity: 1; }
  100% { opacity: 0; transform: scale(1.15); }
}

.narrative-enter-active,
.narrative-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.narrative-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.narrative-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
